module.exports = __webpack_public_path__ + "7125e8df787d7fe4950e4e998e4cc54f.svg";